/**
 * Product Section Navigation — Artemis Therapeutics
 *
 * Always-visible sticky tab bar with scroll-spy. Desktop + mobile.
 * Handles: active-tab highlighting, smooth-scroll on click, and
 * escaping Craft theme's scroll-trigger transform context.
 *
 * Header tracking: The nav dynamically follows the Craft
 * sticky header — sitting below it when visible, sliding
 * to viewport top when the header hides on scroll-down.
 *
 * Revert: Delete this file + product-section-nav.liquid snippet +
 *         CSS section CRO-2c from artemis-custom.css
 */
(function () {
  var nav = document.getElementById('product-section-nav');
  if (!nav) return;

  /* ── Escape scroll-trigger transform context ── */
  document.body.appendChild(nav);

  /* ── Derive section ID prefix from Liquid context ── */
  var sectionId = nav.getAttribute('data-section-id') || '';
  var prefix = '';
  var underscorePos = sectionId.lastIndexOf('__');
  if (underscorePos !== -1) {
    prefix = sectionId.substring(0, underscorePos + 2);
  }

  /* ── Collect section targets ── */
  var tabs = nav.querySelectorAll('.product-section-nav__tab');
  var sections = [];

  tabs.forEach(function (tab) {
    var targetId = 'shopify-section-' + prefix + tab.getAttribute('data-target');
    var el = document.getElementById(targetId);
    if (el) {
      sections.push({ id: targetId, el: el, tab: tab });
    }
  });

  if (sections.length === 0) return;

  /* ── Header tracking ── */
  var headerSection = document.querySelector('.section-header');
  /* Measure actual nav height — responsive (36px mobile, 48px desktop) */
  var navHeight = nav.offsetHeight || 48;

  function getHeaderBottom() {
    if (!headerSection) return 0;
    var bottom = headerSection.getBoundingClientRect().bottom;
    return bottom > 0 ? bottom : 0;
  }

  /* D18 (Lucidia page, Oct 2026): once the header is sticky it slides in and out through its own 150 ms
     transition on `top`, during which no scroll event fires, so the bar lagged up to 65 px behind it. With D18
     the bar takes the header's target and the header's own timing instead of chasing its position. */
  var q3 = document.documentElement.classList.contains('dz-pdp-q3');
  if (q3 && headerSection) {
    new MutationObserver(function () { updateNavPosition(); })
      .observe(headerSection, { attributes: true, attributeFilter: ['class'] });
  }

  function updateNavPosition() {
    if (q3 && headerSection && headerSection.classList.contains('shopify-section-header-sticky')) {
      var target = headerSection.classList.contains('shopify-section-header-hidden') ? 0 : headerSection.offsetHeight;
      nav.classList.toggle('dzq-glide', headerSection.classList.contains('animate'));
      nav.style.transform = 'translateY(' + target + 'px)';
      return;
    }
    if (q3) nav.classList.remove('dzq-glide');
    var headerBottom = getHeaderBottom();
    nav.style.transform = 'translateY(' + headerBottom + 'px)';
  }

  /* ── Show nav immediately (always visible on desktop) ── */
  nav.classList.add('product-section-nav--visible');
  updateNavPosition();

  /* ── Offset product content to clear the fixed nav ── */
  /* CRO T01: on phones with data-mobile-defer, no offset; the nav fades in
     only once the buy button has scrolled out of view. */
  var mainSection = document.getElementById('shopify-section-' + prefix + 'main');
  var deferOnMobile = nav.getAttribute('data-mobile-defer') === 'true';
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var buyButton = mainSection ? mainSection.querySelector('.product-form__submit') : null;

  function isDeferred() {
    /* D05 (design pass 2): with the Lucidia first-screen switch on, desktop defers too */
    return (deferOnMobile && mobileQuery.matches) || document.documentElement.classList.contains('dz-pdp');
  }

  function applyOffset() {
    if (!mainSection) return;
    mainSection.style.paddingTop = isDeferred() ? '0px' : (navHeight + 16) + 'px';
  }

  function updateDeferredVisibility() {
    if (!isDeferred() || !buyButton) {
      nav.classList.remove('product-section-nav--deferred');
      return;
    }
    var pastBuyButton = buyButton.getBoundingClientRect().bottom < 0;
    nav.classList.toggle('product-section-nav--deferred', !pastBuyButton);
  }

  applyOffset();
  updateDeferredVisibility();
  mobileQuery.addEventListener('change', function () {
    applyOffset();
    updateDeferredVisibility();
  });

  /* ── Scroll spy — highlight active section tab ── */
  var activeTab = tabs[0];

  function updateSpy() {
    var headerBottom = getHeaderBottom();
    var offset = headerBottom + navHeight + 20;
    var current = null;

    for (var i = sections.length - 1; i >= 0; i--) {
      if (sections[i].el.getBoundingClientRect().top <= offset) {
        current = sections[i];
        break;
      }
    }

    if (current && current.tab !== activeTab) {
      if (activeTab) activeTab.classList.remove('product-section-nav__tab--active');
      current.tab.classList.add('product-section-nav__tab--active');
      activeTab = current.tab;

      /* Auto-scroll active tab into view */
      current.tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  }

  /* ── Scroll handler ── */
  var spyTicking = false;
  window.addEventListener('scroll', function () {
    /* Position update is synchronous — no rAF delay, stays locked to header */
    updateNavPosition();
    updateDeferredVisibility();

    /* Spy update is less critical — throttle via rAF */
    if (!spyTicking) {
      requestAnimationFrame(function () {
        updateSpy();
        spyTicking = false;
      });
      spyTicking = true;
    }
  }, { passive: true });

  /* ── Click handler — smooth scroll to section ── */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = 'shopify-section-' + prefix + tab.getAttribute('data-target');
      var el = document.getElementById(targetId);
      if (!el) return;

      var headerBottom = getHeaderBottom();
      var offset = headerBottom + navHeight + 8;
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  /* ── Initial spy check ── */
  updateSpy();
})();
